import { useState } from 'react';
import { asyncHandler} from '../../../utils';
import useLoading from '../../../customHooks/useLoading';
import _ from 'lodash';
import apiClient from '../../../apiClient';

export default function useFormRecognizer () {
    const { setLoading } = useLoading();
    const [formQuery, setFormQuery] = useState<boolean>(false);
    const [formFields, setFormFields] = useState({});

    const saveAndRecognizeForm = asyncHandler(async(file: object) => {
        setLoading(true);
        const data = {
            file
        }
        
        const res = await apiClient.post('/analyzeIdentification', data);

        setLoading(false);
        setFormQuery(true);

        if (res.status === 200) {
            const fields = _.get(res, 'data', null);
            for (let key in fields) {
                fields[key].confirmed = false;
            }
            setFormFields(fields);
        }
    });

    return {
        formQuery,
        formFields,
        setFormFields,
        saveAndRecognizeForm
    }

}